import { Static, Type } from '@sinclair/typebox'
import { AiBuilderMessage } from '.'

// The flow is designated, never sent: the server loads it within the caller's project
export const CreateAiBuilderReviewRequest = Type.Object({
    flowId: Type.String(),
    history: Type.Array(AiBuilderMessage),
    rating: Type.Number(),
    comment: Type.String(),
})

export type CreateAiBuilderReviewRequest = Static<typeof CreateAiBuilderReviewRequest>
